// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-0d2c98ab]{display:inline-block;overflow:hidden;position:relative;border-color:#fff;border-style:solid;border-radius:5px;background:#fafafa}.avatar__photo[data-v-0d2c98ab]{width:100%;height:100%;border-radius:50%;object-fit:cover;object-position:center;vertical-align:top}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
